import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ChevronLeft, ChevronRight, Loader2 } from 'lucide-react';
import api from '../lib/api';
import { useLang, tx } from '../i18n/LanguageContext';
import LockedGate from '../components/LockedGate';
import { usePageMeta } from '../lib/seo';
import { SimulationViewer } from '../components/simulation/SimulationViewer';

const Breadcrumb = ({ title }) => {
  const { lang, isRTL } = useLang();
  const L = (ar, en) => tx(lang, ar, en);
  const Sep = isRTL ? ChevronLeft : ChevronRight;
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 rounded-2xl bg-blue-50/70 border border-blue-100 px-4 py-3 mb-6">
      <nav className="flex items-center gap-2 text-sm text-slate-600 min-w-0">
        <Link to="/simulations" className="hover:text-blue-700">{L('المحاكاة التفاعلية', 'Interactive simulations')}</Link>
        <Sep className="w-4 h-4 shrink-0" /><span className="font-bold text-slate-900 truncate">{title}</span>
      </nav>
      <Link to="/simulations" data-testid="sim-back-btn" className="h-11 px-4 rounded-xl border border-blue-300 bg-white text-blue-700 text-sm font-bold inline-flex items-center gap-1.5">
        {L('العودة إلى جميع المحاكاة', 'Back to all simulations')}<Sep className="w-4 h-4" />
      </Link>
    </div>
  );
};

export default function SimulationDetail() {
  const { id } = useParams();
  const { lang } = useLang();
  const L = (ar, en) => tx(lang, ar, en);
  const [sim, setSim] = useState(null);
  const [error, setError] = useState(false);
  usePageMeta(sim && (lang === 'en' && sim.titleEn ? sim.titleEn : sim.titleAr), sim && (lang === 'en' && sim.descEn ? sim.descEn : sim.descAr));

  useEffect(() => {
    setSim(null); setError(false);
    api.get(`/simulations/${id}`).then(r => setSim(r.data)).catch(() => setError(true));
  }, [id]);

  if (error) return (
    <main className="page-y min-h-screen"><div className="site-container text-center py-20" data-testid="sim-not-found">
      <p className="text-slate-600 mb-4">{L('المحاكاة غير موجودة أو لم تُنشر بعد.', 'Simulation not found or not published.')}</p>
      <Link to="/simulations" className="text-blue-700 font-bold">{L('العودة إلى جميع المحاكاة', 'Back to all simulations')}</Link>
    </div></main>
  );
  if (!sim) return <main className="page-y min-h-screen flex justify-center pt-32"><Loader2 className="w-8 h-8 animate-spin text-blue-600" /></main>;
  const title = lang === 'en' && sim.titleEn ? sim.titleEn : sim.titleAr;
  if (sim.locked) return <LockedGate pageTitle={title} pageDesc={lang === 'en' && sim.descEn ? sim.descEn : sim.descAr}>{null}</LockedGate>;

  return (
    <main data-testid="simulation-detail-page" className="page-y min-h-screen pb-24 lg:pb-0">
      <div className="site-container">
        <Breadcrumb title={title} />
        <SimulationViewer sim={sim} />
      </div>
    </main>
  );
}
